import { z } from 'zod';
import { workerEmploymentTypeSchema } from '../zod-schemas/schema';

export const availabilityTypeSchema = z.enum([
  'available',
  'tentative',
  'pending',
  'blocked',
  'unavailablePaid',
  'unavailableUnpaid',
]);
export type AvailabilityType = z.infer<typeof availabilityTypeSchema>;

const availabilitySchema = z.object({
  id: z.string(),
  type: availabilityTypeSchema,
  workName: z.string().nullable(),
  companyName: z.string().nullable(),
  utcStartDateTime: z.string(),
  utcEndDateTime: z.string(),
});

export const workersAvailabilitySchema = z.object({
  workerId: z.string(),
  firstName: z.string(),
  infix: z.string().nullable(),
  lastName: z.string(),
  email: z.string(),
  profilePictureUrl: z.string().optional(),
  availability: z.array(availabilitySchema),
  lenderCompanyName: z.string().nullable(),
  employmentType: workerEmploymentTypeSchema.nullable(),
});

export type WorkersAvailability = z.infer<typeof workersAvailabilitySchema>;

export const workersAvailabilityPaginatedSchema = z.object({
  items: z.array(workersAvailabilitySchema),
  totalRows: z.number(),
  nextPage: z.number().optional(),
  previousPage: z.number().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
});

export type WorkersAvailabilityPaginated = z.infer<typeof workersAvailabilityPaginatedSchema>;
